/**
 * LocalStorage service with error handling
 */
class LocalStorageService {
  /**
   * Get item from localStorage
   * @param key - The key to retrieve
   * @returns The stored value or null if not found or on error
   */
  static getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error("Failed to read from localStorage:", e);
      return null;
    }
  }

  /**
   * Set item in localStorage
   * @param key - The key to store
   * @param value - The value to store
   * @returns true if successful, false otherwise
   */
  static setItem(key: string, value: string): boolean {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      console.error("Failed to write to localStorage:", e);
      return false;
    }
  }

  /**
   * Remove item from localStorage
   * @param key - The key to remove
   */
  static removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error("Failed to remove from localStorage:", e);
    }
  }
}

export default LocalStorageService;

